import { ShieldSwordIcon } from './ShieldSwordIcon';

/**
 * author: Michael Miday
 * id 614C104E-8424-4D0B-AAFB-3D35CCBDF291
 * name shield-sword
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-sword.svg
 * tags
 * - Gaming / RPG 
 */
export const ModeratorIcon = ShieldSwordIcon;
export default ModeratorIcon